declare var require: any;

export const environment = {
  production: true,
  ekulturPrimusAppID: '06571733-ed99-4a83-92bf-78e64236938a',
  ekulturLoginGatewayURL: 'https://login.ekultur.org',
  ekulturAPIGatewayURL: 'https://apigateway.dimu.org',
  version: require('../../package.json').version
};
